import { DEFAULT_COLOR, mapColorToPalette } from '@entities/category';
import * as stylex from '@stylexjs/stylex';
import { styles } from './styles';

interface CategoryLabelProps {
  name: string;
  color?: string;
}

export const CategoryLabel = ({ name, color }: CategoryLabelProps) => {
  const isHasColor = color && color !== DEFAULT_COLOR;

  return <span {...stylex.props(isHasColor ? styles.coloredName(mapColorToPalette[color]) : styles.name)}>{name}</span>;
};
